<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage bonds</small>
      </legend>
      <div></div>
      <div>
        <div class="bondsLoader">
          <span class="spinner-border text-primary spinner-border-sm" role="status" aria-hidden="true"></span>
          <span style="font-size:14px; color: blue"></span>loading bonds...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemBonds"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            
            <span v-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit bond!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewBond(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit bond
              </button>
            </span>

              <span v-else-if="props.column.field == 'Truck'">
              <button
                v-b-tooltip.hover.bottom="'add truck!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewBondtruck(props.row.id)"
              >
                <i class="fa fa-truck"></i> Allocate truck
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter file reference"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter bill of landing"
          }
        },
        {
          label: "Cargo no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "cargo number"
          }
        },
        {
          label: "Cargo size",
          field: "cargo_size",
          type: "text"
        },
        {
          label: "T810 entry",
          field: "t810_entry",
          type: "text"
        },
        {
          label: "T812 entry",
          field: "t812_entry",
          type: "text"
        },
        {
          label: "Bond amount",
          field: "bond_amount",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        },
        {
          label: "Truck allocation",
          field: "Truck",
          width: "122px",
          html: true
        }
      ]
    };
  },

  created() {
    this.loadBonds();
  },
  computed: {
    ...mapGetters(["systemBonds"])
  },
  methods: {
    ...mapActions(["loadBonds", "viewBond","viewBondtruck"])
  }
};
</script>


// WEBPACK FOOTER //
// src/bonds/managebonds.vue